import React from 'react';
import Select from 'react-select';
import { Field } from 'formik';
import './form-elements.scss';

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "5px",
    borderColor: "#87cdf1",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "1rem",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "1rem",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "100%",
    height: "36px",
    overflow: "inherit",
  }),
  Input: (provided) => ({
    ...provided,
    height: "unset",
  }),
  menu: (provided) => ({
    ...provided,
    position: "absolute",
    textAlign: 'left',
    zIndex: '2',
  }),
};

export default ({ name, placeholder, disabled, data, searchable, maxMenuHeight, onChangeHandler = () => { } }) => {
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        let valueData = data?.filter((option) => option.value === field.value)
        if (name === 'miles' && valueData && valueData.length === 0) valueData = [{ label: '200+ Miles', value: '200' }]
        return (
          <div>
            <Select
              className={`react-select-container custom-select-input ${meta.touched && meta.error ? 'error' : ''
                }`}
              classNamePrefix="react-select"
              name={name}
              value={valueData}
              options={data}
              isDisabled={disabled}
              placeholder={placeholder}
              isSearchable={searchable}
              styles={customStyles}
              maxMenuHeight={maxMenuHeight ? maxMenuHeight : 150}
              onChange={(data) => {
                onChangeHandler(data, data.value);
                form.setFieldValue(name, data.value);
              }}
            />

            {meta.touched && meta.error && (
              <p name={name + 'Error'} className='error-message'>{meta.error}</p>
            )}
          </div>
        );
      }}
    </Field>
  );
};
